import * as stylex from '@stylexjs/stylex';
import '../../styles/tokens.stylex';
import { color, negativeSpacing, spacing, typographyColor } from '../../styles/tokens.stylex';
import './tokens.stylex';
import { loaderVars } from './tokens.stylex';
export type LoaderProps = {
  visible?: boolean;
  /** Override size (e.g. from InputGroup tokens). Defaults to loaderVars.size. */
  size?: string;
  styles?: stylex.StyleXStyles;
};
const bars = Array(12).fill(0);
export function Loader({
  visible = true,
  size,
  styles
}: LoaderProps) {
  return <div {...stylex.props(sx.iconWrapper, !!size && sx.iconWrapperSize(size), styles)} data-visible={visible}>
      <div {...stylex.props(sx.spinner, !!size && sx.spinnerSize(size))}>
        {bars.map((_, i) => <div {...stylex.props(sx.loadingBars, sx.loadingBarChild(i))} key={`spinner-bar-${i}`} />)}
      </div>
    </div>;
}
const sonnerSpin = "xim2gf2-B";
const _temp = {
  kogj98: "x11bq41c",
  kZKoxP: "x16ye13r",
  kzqmXN: "x5lhr3w",
  "$$css": true
};
const _temp2 = {
  kKxzle: "xvo38ju",
  kSiTet: "x1ptxcow",
  k3aq6I: "xsqj5wx",
  "$$css": true
};
const sx = {
  iconWrapper: {
    kxichV: "x11x033",
    k1xSpc: "xrvj5dj",
    kVAEAm: "x1n2onr6",
    kZKoxP: "xy7yvro",
    kzqmXN: "xcjocf0",
    kMwMTN: "x1joeokn",
    $$css: true
  },
  iconWrapperSize: (size: string) => [_temp, {
    "--x-height": (val => typeof val === "number" ? val + "px" : val != null ? val : undefined)(`calc(${size} + ${spacing.inset_xxxs})`),
    "--x-width": (val => typeof val === "number" ? val + "px" : val != null ? val : undefined)(`calc(${size} + ${spacing.inset_xxxs})`)
  }],
  spinner: {
    kVAEAm: "x1n2onr6",
    kZKoxP: "xy7yvro",
    kbCHJM: "x1nrll8i",
    k87sOh: "xwa60dl",
    kzqmXN: "xcjocf0",
    $$css: true
  },
  spinnerSize: (size: string) => [{
    kZKoxP: size != null ? "x16ye13r" : size,
    kzqmXN: size != null ? "x5lhr3w" : size,
    $$css: true
  }, {
    "--x-height": (val => typeof val === "number" ? val + "px" : val != null ? val : undefined)(size),
    "--x-width": (val => typeof val === "number" ? val + "px" : val != null ? val : undefined)(size)
  }],
  loadingBars: {
    kaIpWk: "x1ki10ah",
    k44tkh: "x1m9vv7p",
    kWV6AL: "x10e4vud",
    ko0y90: "xa4qsjk",
    kKVMdj: "xal3j3h",
    kyAemX: "x1esw782",
    kWkggS: "xtwfq29",
    kVAEAm: "x10l6tqk",
    kZKoxP: "xpbsij0",
    kbCHJM: "xxuzkb1",
    k87sOh: "x10shg0w",
    kzqmXN: "xu9fw5t",
    $$css: true
  },
  loadingBarChild: (i: number) => [_temp2, {
    "--x-animationDelay": (val => typeof val === "number" ? val + "ms" : val != null ? val : undefined)(`${-1.2 + (i + 1) * (1.2 / 12)}s`),
    "--x-transform": `rotate(${i * 30}deg) translate(146%)` != null ? `rotate(${i * 30}deg) translate(146%)` : undefined
  }]
};